import { bindContainer, buildObjectContainer, injectContainer } from '../impl';
import type { IContainer } from '../interface';

export function injectOrBuildContainer(name = 'default'): IContainer {
    let container = injectContainer(name);

    if (!container) {
        container = buildObjectContainer();
        bindContainer(container, name);
    }

    return container;
}
